<template>
    <div>
        <modal v-model="modalFacturaDetail" dir="right" :modalClass="['fill', 'lg right h100']" 
        :title="`Detalle de Documento`"
        :hideActions="!(tab === 'Documentos Recibidos' && modalFacturaDetail && modalFacturaDetail.type === 33)">
            <i class="options icon-dots-vertical ml5" slot="options" @click="Options([
                { text: 'Imprimir', if: modalFacturaDetail.type == 33, function: () => PrintFactura(modalFacturaDetail), icon: 'print'},
                { text: `Descargar PDF${modalFacturaDetail.type == 33 && !modalFacturaDetail.recieved? ' Tributario' :''}`, function: () => { GetDtePDF(modalFacturaDetail.type, modalFacturaDetail.id, modalFacturaDetail.folio, false, modalFacturaDetail.recieved) }, icon: 'download' },
                { text: 'Descargar PDF Cedible', if: modalFacturaDetail.type == 33 && !modalFacturaDetail.recieved, function: () => { GetDtePDF(modalFacturaDetail.type, modalFacturaDetail.id, modalFacturaDetail.folio, true) }, icon: 'download' },
                { text: 'Ceder factura electrónica', if: !modalFacturaDetail.recieved && modalFacturaDetail.type == 33 && modalFacturaDetail.status == 'OK', function: () => { $refs.modalFacturaElectronica.OpenModalCesion(modalFacturaDetail) }, icon: 'right-arrow' },
                { text: `Enviar ${Util.DTE[modalFacturaDetail.type]}`, class: 'selected-color', function: () => { $refs.modalFacturaElectronica.OpenmodalSendDte(modalFacturaDetail, modalFacturaDetail.type) }, icon: 'mail' }
            ])"></i>

            <div v-if="modalFacturaDetail" class="pa20">
                <div>
                    <div class="f18 mb20">Información</div>

                    <div class="mb15">
                        <div class="bold">Número</div>
                        <div>{{ Util.DTE[modalFacturaDetail.type] }} N°{{ modalFacturaDetail.folio }}</div>
                    </div>

                    <div class="mb15" v-if="modalFacturaDetail.id_track">
                        <div class="bold">Identificador de envío</div>
                        <div>{{ modalFacturaDetail.id_track }}</div>
                    </div>

                    <div class="mb15">
                        <div class="bold">Fecha de creación</div>
                        <div>{{ Util.Date(modalFacturaDetail.created_at, 'LL') }}</div>
                    </div>

                    <div class="mb15">
                        <div class="bold">Fecha de emisión</div>
                        <div v-if="modalFacturaDetail.type == 33">{{ Util.Date(modalFacturaDetail.issue_at, 'LL') }}</div>
                        <div v-else>{{ Util.Date(modalFacturaDetail.send_at, 'LL') }}</div>
                    </div>

                    <div v-if="modalFacturaDetail.status" :class="`mb15 ${Util.FacturaStatus[modalFacturaDetail.status].color}`">
                        <div class="bold">Estado</div>
                        <div>{{ Util.FacturaStatus[modalFacturaDetail.status].label }}</div>
                    </div>
                </div>

                <div>
                    <div class="separator mb20 mt20"></div>

                    <div class="f18 mb20">Emisor</div>

                    <div class="mb15">
                        <div class="bold">RUT</div>
                        <div>{{ Util.TransformRut(modalFacturaDetail.print_data.emisor.RUTEmisor) }}</div>
                    </div>

                    <div class="mb15">
                        <div class="bold">Razón social</div>
                        <div>{{ modalFacturaDetail.print_data.emisor.RznSoc }}</div>
                    </div>
                </div>

                <div v-if="modalFacturaDetail.print_data.receptor">
                    <div class="separator mb20 mt20"></div>

                    <div class="f18 mb20">Receptor</div>

                    <div class="mb15">
                        <div class="bold">RUT</div>
                        <div>{{ Util.TransformRut(modalFacturaDetail.print_data.receptor.RUTRecep) }}</div>
                    </div>

                    <div class="mb15">
                        <div class="bold">Razón social</div>
                        <div>{{ modalFacturaDetail.print_data.receptor.RznSocRecep }}</div>
                    </div>
                </div>

                <div>
                    <div class="separator mb20 mt20"></div>
                    <div class="flex align-center mb20">
                        <div class="f18 flex-fill flex">Items</div>
                        <button v-if="tab == 'Documentos Recibidos' && modalFacturaDetail.type == 33" class="secondary" @click="OpenModalSyncInventory(modalFacturaDetail)">Vincular Ítems</button>
                    </div>

                    <div class="well mb10 flex column" v-for="(item, index) in modalFacturaDetail.print_data.items"
                        :key="index">
                        
                        <div class="bold">{{ item.item }}
                            <span v-if="tab == 'Documentos Recibidos' && modalFacturaDetail.type == 33">
                                <span v-if="item.applied" class="ml5 secondary-text cgreen ta-left">
                                    <i class="icon icon-circle-check"></i> <span v-show="desktop"> Ingresado</span>
                                </span>
                                <span v-else-if="!item.applied && (item.inventory_item_id || item.expense_id)" class="secondary-text ml5 cyellow ta-left">
                                    <i class="icon icon-link"></i> <span v-show="desktop"> Vinculado</span>
                                </span>
                            </span>
                        </div>
                        <div class="bold secondary-text mt10 mb10" v-if="item.description">{{ item.description }}</div>
                        <div class="flex">
                            <div class="w20">
                                <div class="secondary-text">Cantidad</div>
                                <div>{{ Util.Number(item.quantity) }} <span class="secondary-text" v-if="item.unit">{{
                                    item.unit }}</span></div>
                            </div>
                            <div class="w20">
                                <div class="secondary-text">Precio</div>
                                <div>${{ item.price }}</div>
                                <div class="secondary-text">Subtotal</div>
                                <div>${{ item.subtotal? item.subtotal : item.quantity * item.price}}</div>
                            </div>
                            <div class="w20">
                                <div class="secondary-text">Impuesto adicional</div>
                                <div v-if="!item.tax || item.tax == 0">-</div>
                                <div v-else>${{ item.tax }}</div>

                                <div class="secondary-text">IVA</div>
                                <div v-if="!item.iva">-</div>
                                <div v-else>${{ item.iva }}</div>
                            </div>
                            <div class="w20">
                                <div class="secondary-text">Descuento</div>
                                <div v-if="!item.discount || item.discount == 0">-</div>
                                <div v-else>${{ item.discount }}</div>

                                <div class="secondary-text">Mnt neto</div>
                                <div v-if="!item.neto || item.neto == 0">-</div>
                                <div v-else>${{ item.neto }}</div>
                            </div>
                            <div class="w20 ta-right">
                                <div class="secondary-text">Total</div>
                                <div class="bold">${{ item.total ? item.total : modalFacturaDetail.print_data.total}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="separator mb20 mt20"></div>

                    <div class="f18 mb20">Total</div>

                    <div class="mb15">
                        <div class="bold">Neto</div>
                        <div>${{ modalFacturaDetail.print_data.neto }}</div>
                    </div>

                    <div class="mb15">
                        <div class="bold">IVA 19%</div>
                        <div>${{ modalFacturaDetail.print_data.iva }}</div>
                    </div>

                    <div class="mb15">
                        <div class="bold">Impuesto adicional</div>
                        <div>${{ modalFacturaDetail.print_data.impuestoAdicional }}</div>
                    </div>

                    <div class="mb15">
                        <div class="bold">Descuentos</div>
                        <div>${{ modalFacturaDetail.print_data.discount? modalFacturaDetail.print_data.discount : 0 }}</div>
                    </div>

                    <div class="mb15">
                        <div class="bold">Descuento Global</div>
                        <div>${{ modalFacturaDetail.print_data.globalDiscount ? modalFacturaDetail.print_data.globalDiscount : 0 }}</div>
                    </div>

                    <div class="mb20">
                        <div class="bold">Total</div>
                        <div>{{ Util.Price(modalFacturaDetail.total) }}</div>
                    </div>

                    <div v-if="modalFacturaDetail.print_data.payment_method">
                        <div class="f18 mb15">Método de Pago</div>
                        <div>{{Util.PayMethod(modalFacturaDetail.print_data.payment_method)}}</div>
                    </div>
                </div>
            </div>

            <button slot="actions" class="primary purple" @click="OpenModalApplyLinks(modalFacturaDetail)">Ingresar Ítems Vinculados</button>
        </modal>
        <modal v-model="modalSyncInventory" dir="right" :modalClass="['fill', 'sm right h100']" title="Vincular ítems">
            <div class="pa20" v-if="modalSyncInventory">
                <div class="secondary-text mb20">
                    Vincula cada ítem de esta factura a un gasto o a un ítem de inventario.  
                    <br>
                    • Si vinculas a un <strong>Gasto</strong>: la cantidad se sumará al gasto correspondiente.<br>
                    • Si vinculas a un <strong>Ítem de Inventario</strong>: la cantidad se añadirá al stock disponible.<br><br>
                </div>

                <div 
                    class="well mb20 pa15"
                    v-for="(item, index) in modalSyncInventory.items"
                    :key="index"
                >
                    <div class="bold mb5">{{ item.item }}</div>
                    <div class="secondary-text mb10">Cantidad: {{ Util.Number(item.quantity) }} <span v-if="item.link_type == 'INVENTORY' && item.equivalent_quantity > 1">(transformado a {{ item.quantity * item.equivalent_quantity }})</span> — Total: ${{ item.total }}</div>

                    <input-select
                        class="mb10"
                        v-model="item.link_type"
                        :items="[
                            { text: 'No Vincular', value: null },
                            { text: 'Vincular a inventario', value: 'INVENTORY' },
                            { text: 'Vincular a gasto', value: 'EXPENSE' },
                        ]"
                    ></input-select>

                    <input-select
                        v-if="item.link_type == 'INVENTORY'"
                        label="Ítem de inventario"
                        v-model="item.inventory_item_id"
                        canType
                        :items="inventoryItems"
                    ></input-select>

                    <input-select
                        v-if="item.link_type == 'EXPENSE'"
                        label="Gasto"
                        v-model="item.expense_id"
                        :items="expenseItems"
                        canType
                    ></input-select>

                    <input-field
                        class="mt10"
                        v-if="item.link_type == 'INVENTORY'"
                        v-model="item.equivalent_quantity"
                        label="Cantidad Transformada"
                        type="float+"
                        info="Indica la cantidad de inventario que se debe ingresar por cada ítem de la factura"
                    ></input-field>
                </div>
            </div>

            <button slot="actions" class="primary purple" @click="SyncInventory()">Vincular</button>
        </modal>
        <modal v-model="modalApplyLinks" dir="right" :modalClass="['fill', 'md right h100']" title="Ingresar Ítems Vinculados">
            <div class="pa20" v-if="modalApplyLinks && modalApplyLinks.items">

                <div class="secondary-text ta-center mt10" v-if="modalApplyLinks.items.length == 0">No hay productos vinculados</div>

                <input-select
                v-if="modalApplyLinks.items.length"
                v-model="modalApplyLinks.provider" 
                :items="providersItems"
                :triggerFirstValueChanged="false"
                @OnValueChanged="AddProvider($event)"
                canType
                label="Proveedor"
                class="mb15">
                </input-select>
                <input-field v-if="modalApplyLinks.new_provider" class="mb15"
                v-model="modalApplyLinks.rut"
                label="RUT">
                </input-field>

                <div class="well mb15" :style="{padding: '0px'}" v-for="(item, index) in modalApplyLinks.items" :key="index">
                    <div :class="`pa10 cw flex align-center ticket-header`">
                        <label class="mt5">
                            <input type="checkbox" v-model="item.apply"> {{item.item_name_factura}} <div class="checkmark"></div>
                        </label> 
                    </div>

                    <div class="pa15 pt0" v-show="item.apply">
                        <div class="bold mb5">{{ item.item_name }}</div>

                        <div v-if="item.type === 'INVENTORY'" class="mt10">
                            <span class="bold">Ingreso de inventario</span><br>
                            Se ingresarán <span class="bold">{{ Util.Number(item.add_quantity) }}</span> unidades

                            <div class="flex align-center mt10">
                                <div class="">
                                    <div class="bold">Cantidad</div>
                                    <div><span>{{Util.Number(item.old_quantity)}}</span></div>
                                </div>
                                <i class="icon icon-arrow-right ml20 mr20 c4"></i>
                                <div class="">
                                    <div class="bold">Nueva cantidad</div>
                                    <div><span>{{Util.Number(item.future_quantity)}}</span></div>
                                </div>
                            </div>
                        </div>

                        <div v-if="item.type === 'EXPENSE'" class="mt10">
                            <span class="bold">Ingreso de gasto</span><br>
                            Se ingresará <span class="bold">${{ item.total_cost }}</span>
                        </div>
                    </div>
                </div>
                <label class="" v-if="modalApplyLinks">
                    <input type="checkbox" v-model="modalApplyLinks.pending"> Pago pendiente <div class="checkmark"></div>
                </label>

                <input-select class="mt15" label="Método de Pago" v-model="modalApplyLinks.pay_method" :items="payMethods" v-show="modalApplyLinks && !modalApplyLinks.pending"></input-select>
            </div>

            <button slot="actions" class="primary purple" @click="ApplySyncInventory()">Ingresar</button>
        </modal>
        <modal-factura-electronica ref="modalFacturaElectronica"></modal-factura-electronica>
    </div>
</template>

<script>
export default {
    data() {
        return {
            modalFacturaDetail : null,
            modalSyncInventory : null,
            modalApplyLinks : null,
            providers : [],
            inventoryItems: [],
            expenseItems: [],
            payMethods : [{text: 'Sin definir', value: 'UNDEFINED'}]
        }
    },
    props : {
        tab : {
            type : String,
            default : ''
        }
    },
    methods : {
        OpenModalFacturaDetail(dte, index) {
            if(dte.type != 33) return this.modalFacturaDetail = {...dte, recieved: true, idx: index};
            this.Loading();
            axios.put(`/sii/dte/${dte.id}/items/link`).then(({data}) => {
                this.Response(data);
                this.modalFacturaDetail = {...data, recieved: true, idx: index};
                this.providers = data.providers;
                this.GetImpuestoAdicionalItem();
            }).catch(err => {
                this.Response(err);
            });
        },
        OpenModalApplyLinks(factura) {

            if(!factura) return;
            let items = factura.print_data.items;
            let canPass = items.some(item => item.inventory_item_id || item.expense_id );
            if(!canPass) return this.Info("No existen items vinculados o ingresdos");

            this.Loading();
            axios.post(`sii/inventory/${this.Local.id}/linking/preview`, { items: factura.print_data.items }).then(({data}) => {
                for(var i = 0; i < data.methods.length; i++)
                    this.payMethods.push({text: this.Util.PayMethod(data.methods[i]), value: data.methods[i]});
                
                let previews = data.preview;
                previews.forEach(prew => {
                    let find = factura.print_data.items.find(item => item.item == prew.item_name_factura);
                    if (!find) return;

                    prew.price = find.price;
                    prew.iva = find.iva;
                    prew.quantity = find.quantity;
                    prew.subtotal = find.subtotal;
                    prew.total = find.total;
                    prew.tax = typeof find.tax === "string" ? parseInt(find.tax.replace(/[.$]/g, ''), 10) : find.tax;
                    prew.discount = find.discount ? find.discount : 0;
                    
                });

                this.modalApplyLinks = { items: previews, id_factura: factura.id, idx: factura.idx, pending: false, pay_method:[]};

                let rutFactura = this.modalFacturaDetail.provider
                ? this.modalFacturaDetail.provider.toLowerCase()
                : this.modalFacturaDetail.print_data.emisor.RUTEmisor.replace(/[.\-]/g, '').toLowerCase();
                
                let itemFound = this.providersItems.find(item => {
                    if(item.value) return item.value.rut === rutFactura;
                });
                
                if (itemFound) {
                    this.$set(this.modalApplyLinks, 'provider', itemFound.value);
                    this.$set(this.modalApplyLinks, 'new_provider', false);
                } else {
                    this.$set(this.modalApplyLinks, 'provider', this.modalFacturaDetail.print_data.emisor.RznSoc);
                    this.$set(this.modalApplyLinks, 'new_provider', true);
                    this.$set(this.modalApplyLinks, 'rut', this.modalFacturaDetail.print_data.emisor.RUTEmisor);
                }
                this.Response("OK");
            }).catch(err => {
                this.Response(err);
            });
        },

        OpenModalSyncInventory(factura) {
            this.Loading();

            Promise.all([
                axios.get(`/inventory/${this.Local.id}/current`),
                axios.get(`/expenses/${this.Local.id}`)
            ])
            .then(([inventoryRes, expensesRes]) => {
                const inventoryData = inventoryRes.data;
                const expensesData  = expensesRes.data.types;

                this.modalSyncInventory = { 
                    items: (factura.print_data.items || []).map(it => ({
                        ...it,
                        equivalent_quantity: it.equivalent_quantity? it.equivalent_quantity : 1
                    })),
                    id_factura: factura.id,
                    idx: factura.idx
                };

                const itemsArray = Object.values(inventoryData || {});
                this.inventoryItems = itemsArray.map(item => ({
                    text: item.title,
                    value: item.id
                }));

                const expenseItems = Object.values(expensesData || {});
                this.expenseItems = expenseItems.map(expense => ({
                    text: expense.title,
                    value: expense.id
                }));

                //check missing items
                this.modalSyncInventory.items.forEach(item => {
                    if(item.link_type == 'INVENTORY')
                    {
                        let inventoryItem = itemsArray.find(it => it.id == item.inventory_item_id);
                        if(!inventoryItem)
                        {
                            item.inventory_item_id = null;
                            item.link_type = null;
                        }
                        console.log(inventoryItem);
                    }
                    else if(item.link_type == 'EXPENSE')
                    {
                        let inventoryItem = expenseItems.find(it => it.id == item.expense_id);
                        if(!inventoryItem)
                        {
                            item.expense_id = null;
                            item.link_type = null;
                        }
                    }
                });

                this.Response("OK");
            })
            .catch(err => {
                console.log(err);
                this.Response(err);
            });
        },
        GetImpuestoAdicionalItem() {
            try {
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(this.modalFacturaDetail.xml, "text/xml");

                const ns = "http://www.sii.cl/SiiDte";
                const detalleNodos = xmlDoc.getElementsByTagNameNS(ns, "Detalle");
                const dscRcgGlobalNodos = xmlDoc.getElementsByTagNameNS(ns, "DscRcgGlobal");
                const montoImpNodos = xmlDoc.getElementsByTagNameNS(ns,"MontoImp");

                let totalDiscount = 0;
                let totalGlobalDiscount = 0;
                let totalImpuestoMonto = 0;

                if(montoImpNodos) {
                    for (let i = 0; i < montoImpNodos.length; i++) {
                        totalImpuestoMonto += parseInt(montoImpNodos[i].textContent, 10);
                    }
                }
                
                if (this.modalFacturaDetail.print_data && this.modalFacturaDetail.print_data.impuestoAdicional && this.modalFacturaDetail.print_data.impuestoAdicional > 0) {
                    if(typeof this.modalFacturaDetail.print_data.impuestoAdicional == 'string') this.modalFacturaDetail.print_data.impuestoAdicional = this.modalFacturaDetail.print_data.impuestoAdicional = parseInt(this.modalFacturaDetail.print_data.impuestoAdicional.replace(/\./g, ''));
                }else {
                    this.modalFacturaDetail.print_data.impuestoAdicional = totalImpuestoMonto;
                }

                if(dscRcgGlobalNodos) {
                    for (let i = 0; i < dscRcgGlobalNodos.length; i++) {
                        let global = dscRcgGlobalNodos[i];
                        
                        let discountItem = global.getElementsByTagNameNS(ns, "ValorDR")[0] ? global.getElementsByTagNameNS(ns, "ValorDR")[0].textContent.trim() : null;
                        totalGlobalDiscount += parseInt(discountItem, 10);
                        
                    }
                }

                if(!this.modalFacturaDetail.print_data.globalDiscount) this.modalFacturaDetail.print_data.globalDiscount = totalGlobalDiscount;

                totalDiscount = totalGlobalDiscount;
                for (let i = 0; i < detalleNodos.length; i++) {
                    let item = detalleNodos[i];
                    
                    const codImpAdicNode = item.getElementsByTagNameNS(ns, "CodImpAdic")[0] ? item.getElementsByTagNameNS(ns, "CodImpAdic")[0].textContent.trim() : null;
                    const nameNode = item.getElementsByTagNameNS(ns, "NmbItem")[0].textContent.trim();
                    const qtyNode = item.getElementsByTagNameNS(ns, "QtyItem")[0].textContent.trim();
                    const montoDescuentoNode = item.getElementsByTagNameNS(ns, "DescuentoMonto")[0] ? item.getElementsByTagNameNS(ns, "DescuentoMonto")[0].textContent.trim() : null;
                    const montoItemNode = parseInt(item.getElementsByTagNameNS(ns, "MontoItem")[0].textContent.trim(),10);
                    
                    let find = this.modalFacturaDetail.print_data.items.find(item => decodeURIComponent(escape(item.item)) === nameNode);
                    
                    if(montoDescuentoNode && find && !find.discount) {
                        find.discount = this.Util.Number(montoDescuentoNode);
                        totalDiscount +=  parseInt(montoDescuentoNode.replace(/[^\d-]/g, ""), 10);
                    }
                    else if(montoDescuentoNode && find && find.discount) {
                        totalDiscount += parseInt(find.discount.replace(/[^\d-]/g, ""), 10);              
                    }
                    if (codImpAdicNode && find && !find.tax) find.tax = this.Util.Number((montoItemNode * (this.Util.TaxCodes[codImpAdicNode] / 100)/qtyNode).toFixed(1));

                    if(find && !find.iva) find.iva = this.Util.Number((montoItemNode*0.19).toFixed(0));
                }
                
                this.modalFacturaDetail.print_data.discount = this.modalFacturaDetail.print_data.discount ? this.modalFacturaDetail.print_data.discount : this.Util.Price(totalDiscount);

            } catch (e) {
                console.error(e);
                return ;
            }
        },
        GetDtePDF(typeDte = 33, idDte, folio, cedible = 0, recieved) {
            this.Loading();
            axios.post(`/sii/dte/pdf`, {
                idDte,
                typeDte, 
                cedible,
                recieved
            }, {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/pdf'
                }
            })
            .then((res) => {
                if(typeDte == 56){
                    this.Util.DownloadFile(res, `nota_debito_${folio}.pdf`);
                    return this.Response(res);
                }

                if(typeDte == 52){
                    this.Util.DownloadFile(res, `guia_despacho_${folio}.pdf`);
                    return this.Response(res);
                }

                if(typeDte == 61){
                    this.Util.DownloadFile(res, `nota_credito_${folio}.pdf`);
                    return this.Response(res);
                }

                this.Util.DownloadFile(res, `factura_electronica_${folio}_${cedible? 'cedible' : ' tributaria'}.pdf`);
                this.Response(res);
            })
            .catch(err => {
                this.Response(err);
            });
        },
        PrintFactura(factura) {
            this.Util.NotifyService('factura', {data: factura.print_data, id: Math.random().toString()});
        },
        ApplySyncInventory(){
            let canPass = this.modalApplyLinks.items.some(item => item.apply);            
            if(!canPass) return this.Info("Debes seleccionar al menos 1 item");
            if(!this.modalApplyLinks.items.length) return this.Info(`No hay productos vinculados`);
            if(this.modalApplyLinks && this.modalApplyLinks.new_provider && this.providers[this.modalApplyLinks.rut]) return this.Info(`El RUT ingresado ya existe en los proveedores`);            
            this.Loading();
            let has_rut = true;
            if(this.modalApplyLinks && !this.modalApplyLinks.rut) {
                has_rut = false;
                this.modalApplyLinks.rut = this.Util.GenerateRandomRut();
            }
            axios.post(`sii/inventory/${this.Local.id}/linking/apply`, {
                items: this.modalApplyLinks.items,
                provider: this.modalApplyLinks.new_provider ? {name : this.modalApplyLinks.provider, rut : this.modalApplyLinks.rut.toLowerCase(), has_rut : has_rut ? 1 : 0} : this.modalApplyLinks.provider,
                id: this.modalApplyLinks.id_factura,
                pending : this.modalApplyLinks.pending,
                pay_method : this.modalApplyLinks.pending ? "PENDING_PAYMENT" : this.modalApplyLinks.pay_method,
                global_discount : this.modalFacturaDetail.print_data.globalDiscount ? parseInt(this.modalFacturaDetail.print_data.globalDiscount.replace(/\./g, ''),10) : 0
            })
            .then(({ data }) => {
                if (!data.success) return this.Response(data.message);
                this.modalFacturaDetail = {...data.factura, recieved: true}
                this.$emit('SyncInventory',{ idx : this.modalApplyLinks.idx, data : data.factura})
                // this.dtesReceived[this.modalApplyLinks.idx] = data.factura;
                if(this.modalApplyLinks.new_provider) this.$set(this.providers, this.modalApplyLinks.rut.replace('-', ''), {name : this.modalApplyLinks.provider, has_rut : 1});
                this.modalApplyLinks = null;
                this.GetImpuestoAdicionalItem();
                return this.Info(data.message);
            })
            .catch(err => {
                this.Response(err);
            });
        },
        SyncInventory(){
            this.Loading();
            axios.post(`sii/inventory/${this.Local.id}/linking`, this.modalSyncInventory).then(({data}) => {
                if(!data.success) return this.Response();
                this.modalFacturaDetail = {...data.factura, recieved: true};
                this.$emit('SyncInventory', { idx:this.modalSyncInventory.idx, data : data.factura});
                // this.dtesReceived[this.modalSyncInventory.idx] = data.factura;
                this.GetImpuestoAdicionalItem();
                this.modalSyncInventory = null;
                this.Info(data.message);
            }).catch(err => {
                this.Response(err);
            });
        },
        AddProvider(provider){
            if(provider == '') {
                this.$set(this.modalApplyLinks, 'provider', null);
                this.$set(this.modalApplyLinks, 'new_provider', false);
            }
            if(typeof provider == 'object') return this.$set(this.modalApplyLinks, 'new_provider', false);
            let find = Object.values(this.providers).find(item => item.name == provider);
            if(!find) this.$set(this.modalApplyLinks, 'new_provider', true);           
        }
    },
    computed: {
        providersItems() {

            var ret = [{text: 'Sin proveedor', value: null}];
            if(!this.providers) return ret;
            for(var key in this.providers){
                var name = this.providers[key].name;
                var has_rut = this.providers[key].has_rut;
                ret.push({text: `${name} ${!has_rut? '' : '- '+key}`, value: {rut: key, name: name, has_rut : has_rut}});
            }
            return ret;
        }
    },
}
</script>
